import {Module} from '@fantasmagames/slot/src/common/Module';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {GameRulesView} from '@fantasmagames/slot/src/modules/gamerules/GameRulesView';
import {RecordData} from '@fantasmagames/slot/src/config/GameConfig';

export class GameRulesModule extends Module<GameRulesView> {
	public init(): void {
		super.init();

		if (this.logic.config) {
			const config = this.logic.config.getConfigByName('relaxConfig') as RecordData;

			if (config) {
				this.view.replaceRelaxTimeStamp(config.getParameter('relax_timestamp') as string);
			}
		}
	}

	public afterInit(): void {
		super.afterInit();

		if (this.logic.config) {
			const rtpConfig = this.logic.config.getConfigByName('rtpValues') as RecordData;
			const versionConfig = this.logic.config.getConfigByName('gameVersion') as RecordData;
			const buildConfig = this.logic.config.getConfigByName('buildDate') as RecordData;

			if (rtpConfig) {
				this.view.replaceRTPData(rtpConfig);
			}

			if (versionConfig) {
				this.view.replaceGameVersion(versionConfig.getParameter('version') as string);
			}

			if (buildConfig) {
				this.view.replaceRelaxTimeStamp(buildConfig.getParameter('timestamp') as string);
			}
		}
	}

	protected setupStates(): void {
	}

	protected enterFirstState(): void {
	}

	protected setupViews(): void {
		this.setView(Views.GAME_RULES_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();
		this.on(MainMenuEvents.MAIN_MENU_INFO_OPEN, this.showGameRules);

		this.on(MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.hideGameRules);
		this.on(MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.hideGameRules);
		this.on(MainMenuEvents.MAIN_MENU_CLOSED, this.hideGameRules);
	}

	protected hideGameRules(): void {
		this.view.hide();
	}

	protected showGameRules(): void {
		this.view.show();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/gamerules/GameRulesModule.ts